module.exports = __webpack_public_path__ + "static/media/volkswagen-go-drive.c13f00f2.jpg";